<mat-card data-qa="zuweisung-card">
  <div class="background-{{zuweisung.aufgabe.type}}">
    <mat-card-actions>
      <div class="type type-{{zuweisung.aufgabe.type}}">{{zuweisung.aufgabe.type | aufgabeTypeReadable}}</div>
      <div class="ersteller">Erstellt von <b>{{zuweisung.ersteller.name}}</b></div>
    </mat-card-actions>
    <mat-card-title>
      <h3 data-qa="title">{{zuweisung.aufgabe.name}}</h3>
    </mat-card-title>
    <mat-card-content>
      <div data-qa="kurzbeschreibung">{{kurzbeschreibungShortened}}</div>
    </mat-card-content>
  </div>
  <div class="progress">
    <mat-card-actions>
      <div class="info" data-qa="zuweisung-card-status">
        <mat-icon>playlist_add_check</mat-icon>
        {{ zuweisung.gelesen | zuweisungGelesenReadable: zuweisung.aufgabe.type }}
      </div>
      <div class="info">
        <mat-icon> {{zuweisung.aufgabe.type | aufgabeTypeImage}}</mat-icon>
        {{zuweisung.aufgabe.type | aufgabeTypeFristPrefix}}:&nbsp;{{zuweisung.aufgabe.frist | date: 'dd.MM.yyyy'}}
      </div>
      @if (zuweisung.aufgabe.hatDokument) {
        <div
          class="info" data-qa="zuweisungCardHatDokument"
        >
          <mat-icon>attach_file</mat-icon>
          Anhang
        </div>
      }

    </mat-card-actions>
    <div class="indicator-container">
      <div
        class="indicator indicator-{{zuweisung.gelesen ? 'green' : 'red' }}"
        >&nbsp;
      </div>
    </div>
  </div>
</mat-card>
